"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  com: {
    rent: {
      settleOfficeNameEn: '签约主体',
      importStopPast: '导入停租停航',
      stopImportVoyageFee: '冲销往期停租停航信息',
      parnerWarn: '请填写实际收款人',
      otherFeeWarn: '请填写杂费',
      mustHasInvoiceNo: '发票号不能为空',
      existMess: '不存在相关的维护数据',
      actualRobMessage: '不存在实际还船存油数据不可添加',
      estRedeliverRobMessage: '不存在预计还船存油数据不可添加',
      robMessage: '已存在实际还船存油不可维护预计还船存油数据',
      toVoidThis: '是否作废此发票？',
      messAge: '请至少选择两条数据以上',
      huanDelTime: '还船时间(UTC/LT)',
      lastInstallment: '最后一期',
      currencyCodeMessage: '付款金额小于收款金额，不能申请付款单！',
      mergeApply: '合并付款申请',
      errMsg: '存在已审核的数据,不能进行删除',
      lookApprove: "查看审批流程",
      stopProportion: '计算比例',
      stopPrice: '停租日租金',
      stopDay: '停租天数',
      stopDescription: '停租描述',
      stopPast: '冲销往期',
      openLastMsg: '是否确定开放最后一期?',
      closeLastMsg: '是否确定关闭最后一期?',
      openLast: '开放最后一期',
      closeLast: '关闭最后一期',
      DeleteAudit: '取消审核',
      autidSuccess: '审核成功',
      autidFaild: '取消审核成功',
      estOil: '预计油耗',
      deliverTitle: '交船存油',
      returnTitle: '还船存油',
      eatDeliverTitle: '预计还船存油',
      stopType: "停租扣减",
      naviType: '类型',
      navigationButton: '添加停租',
      saveCve: '添加CVE',
      rentText: '租金费用',
      manageText: '管理费用',
      chargeRentText: '冲销租金费用',
      chargeManageText: '冲销管理费用',
      aRedPort: '还船信息',
      aDelTime: '交船时间(UTC/LT)',
      aDelPort: '交船信息',
      returnShip: '交还船信息',
      periodRentDay: '日租金',
      periodRentType: '租金类型',
      periodEndTime: '租期结束时间',
      periodStartTime: '租期开始时间',
      priceRentTitle: '租出船租金发票',
      monthlyExpensesTitle: '商务代管船租金发票维护',
      inPriceRentTitle: '租入船租金发票',
      apply: '付款申请',
      delete: '删除',
      approve: '审批流程',
      chartererName: '租家',
      chartererCommRate: '租家佣金率',
      freightComm: '运价佣金',
      freightCommRate: '运价佣金率',
      brokerComm: '经纪人佣金率',
      contractNo: '合同号',
      invoiceNo: '发票号',
      invoiceNo2: '发票号',
      invoiceType: '开票类型',
      invoiceDate: '发票日期',
      dueDate: '到期日',
      invalidFlag: '是否作废',
      currencyCode: '币种',
      invoiceAmount: '金额',
      installment: '期数',
      checkFlag: '审核状态',
      title: '租出船运费发票',
      rentOutFreightTitle: '租出船运费发票',
      rentInFreightTitle: '租入船运费发票',
      currency: '币种/汇率',
      InvoiceInformation: '发票信息',
      sundryFees: '杂费费用科目不能为空',
      bdiDate: '指数租金时间不能为空',
      basicFees: '租金费用科目不能为空',
      basicBegin: '租金费用开始时间不能为空',
      basicEnd: '租金费用结束时间不能为空',
      creditNoteFlag: '发票/Credit Note',
      invoiceProperty: '过程票/实际票',
      autoTaxInvFlag: '自动税票申请',
      bankInfo: '银行信息',
      remark: '备注',
      vesselCmpInfo: '单船公司签发信息',
      manageCmpInfo: '管理公司签发信息',
      manageCompany: '管理公司',
      contractTitle: '合同信息',
      finalFlag: '最后一期',
      coaContractNo: '所属COA合同',
      chartererCommOne: '租家回佣',
      chartererComm2: '滞速佣金率',
      demuCommRate: '滞速佣金率',
      demuComm: '滞速佣金',
      partnerName: '实际付款人',
      actualPayer: '实际付款人',
      actualPayee: '实际收款人',
      peopleInfo: '经纪信息',
      cargoName: '货物名称',
      cargoQty: '装货量',
      portCode: '装港',
      tfPortCode: '卸港',
      portCodeTitle: '货物/装卸港信息',
      basicCargoQtyRange: '基本货量区间',
      cargoBLQuantity: '货物/提单货量',
      cargoOqMin: '超出货量下限',
      cargoOqMax: '超出货量上限',
      unloadQty: '卸货量',
      cargoOqStandards: '费率',
      fiveTab: '费用明细',
      sixTab: '附件信息',
      saveOne: '添加亏舱费',
      addKuiFee: '添加亏舱费',
      saveTwo: '添加杂费',
      addBasicFreight: '添加基本运费',
      addIncidentals: '添加杂费',
      saveThree: '导入滞期费',
      importDemurrage: '导入滞速费',
      importVoyageFee: '导入航次杂费',
      freightStd: '计费标准',
      freightBillingStd: '运价计费标准',
      demuBillingStd: '滞速计费标准',
      saveFour: '添加滞速费',
      saveFive: '添加租家佣金',
      renterComm: '租家佣金',
      operation: '操作',
      priseType: '费用类型',
      calculation: '参与佣金计算',
      cushion: '代垫',
      cushionObject: '代垫对象',
      prise: '费用',
      unit: '单位',
      Debit: 'Debit',
      Credit: 'Credit',
      basic: '基本运费',
      number: 'Base on 100% FRT',
      rentTitle: '租家回佣',
      people: '经纪人佣金',
      kuiPrice: '亏舱费',
      sundry: '杂费',
      offSundry: '冲销杂费',
      demurrage: '滞期费',
      excessFreight: '超出运费',
      save: '保存',
      close: '关闭',
      contract: '查看合同',
      ship: '船舶调度',
      audit: '审核',
      cancelAudit: '取消审核',
      priceAudit: '应收发票审批',
      pay: '付款申请',
      print: '打印',
      seal: '电子印章',
      rate: '租家/船东评分',
      tailStage: '尾期',
      nonTailStage: '非尾期',
      pendingFreight: '待处理运费',
      paymentDate: '到款日',
      searchFilter: '可查询发票号',
      payeePayer: '收付款方',
      electSeal: '电子印章',
      cancelElectSeal: '取消电子印章',
      isElectSealRemark: '是否进行标记电子印章？',
      isCancelElectSealRemark: '是否取消标记电子印章？',
      electSealSuccess: '标记电子印章成功',
      cancelElectSealSuccess: '取消标记电子印章成功',
      electSealFail: '标记电子印章失败',
      cancelElectSealFail: '取消标记电子印章失败',
      currentBill: '查看当期账单',
      rollBill: '返回滚动账单',
      printCurrentBill: '当期票账单',
      printRollingBill: '滚动账单',
      printPaymentRequest: '付款申请单',
      checkPrintPayment: '无付款申请费用，不能打印'
    },
    orderAmountDiff: '发票费用行金额与订单不一致，是否回写更新订单？',
    contractTaxRate: '合同税率(%)',
    uploadinvoice: '上传发票',
    SOAImport: 'SOA导入',
    mark: '标记',
    matchType: '匹配类型',
    taxInvoiceCode02: '税票代码',
    invoiceNo02: '匹配形票号',
    taxInvoiceNo02: '税票号码',
    oriTaxInvoiceNo02: '蓝税票号',
    currencyCode02: '原币',
    preTaxInvoiceAmount02: '汇率金额',
    taxInvoiceAmount03: '汇率总金额',
    partnerName03: '购方企业名称',
    partnerAccountNo02: '银行账号',
    partnerContractAddrAndTel: '地址电话',
    invoiceDate02: '开票日期',
    taxClassifyCode: '税收分类编码',
    taxClassify02: '商品编码版本号',
    serviceName02: '商品名称',
    matchDetail: '匹配明细',
    viewMatchInfo: '查看匹配信息',
    invoiceTitle: '租家抬头',
    application: '操作人',
    invSerialNo: '发票流水号',
    checkName: '审核者',
    checkTime: '审核时间',
    searchFilter: '可查询形票号、税票号',
    searchFilterTwo: '可查询航次号、形票号',
    searchFilterThree: '可查询发票号、税票号',
    rpFlagOne: '收付标志',
    addstick: '生成航次单据',
    errorInfo: '所选择数据不符合废弃条件',
    scrap: '废弃',
    bankInfoId: 'FILEID',
    accountNo1: '对象代码',
    bankName1: '银行信息',
    currency1: '币种代码',
    buttonSave: '生成航次单据',
    compLtHan: '已过天数',
    compLt: '航次结束时间',
    isAdvance: '代垫',
    dueDate1: '截止日期',
    feeType: '费用类型',
    remark1: '描述',
    toFrt: '是否开票',
    rpFlag: '收/付',
    abandon: '状态',
    toArap: '应收应付',
    checkStatus1: '审核',
    customerName: '收/付款方',
    portName1: '港口',
    lastModifyByName1: '操作人',
    taxManagement: '税票开票管理',
    taxApplyManagement: '税票申请管理',
    vesselName: '船名',
    voyageNo: '航次',
    currency: '形票币种',
    businessType: '业务类型',
    fleet: '船队',
    partner: '结算对象',
    applicationDateFr: '申请时间从',
    applicationDateTo: '申请时间到',
    applicationStatus: '申请状态',
    invoiceNo: '形票号',
    invoiceNo03: '业务单号',
    settleCompany: '开票公司',
    checkTax: '查看形票',
    taxInvoicing: '税票开票',
    currencyCode: '形票币种',
    invoiceAmount: '形票金额',
    taxInvoiceAmount: '税票金额',
    taxInvoiceAmount02: '税价合计',
    taxApplicationTime: '申请时间',
    taxApplicationTime02: '交易时间',
    settledAmount: '核销金额',
    balanceAmount: '余额',
    settledStatus: '核销状态',
    taxInvoicedAmount: '已开税票',
    spactickTicket: '纸质专票管理',
    business: '商务管理',
    invoicing: '税控开票相关',
    serviceName: '服务名称',
    taxApplicationStatus: '申请状态',
    partnerName: '购方名称',
    // invoiceNo: '形票号',
    taxinvoice: '税票号',
    // invoiceAmount: '形票金额',
    // taxInvoiceAmount: '税票金额',
    voyageNo2: '航次号',
    settleOfficeName: '销方',
    // currencyCode: '形票币种',
    taxCurrencyCode: '税票币种',
    taxExchangeRate: '约定汇率',
    groupExchangeRate: '集团下发汇率',
    invoiceType: '税票发票类型',
    paperTicket: '纸质普票管理',
    ElectronicTicket: '电子普票管理',
    applicationDate: '申请时间',
    selectRight: '请选择正确的组织',
    taxApplyDetailed: '税票申请明细',
    mainInformation: '主信息',
    invoiceHeader: '销方名称',
    taxNumber: '销方税号',
    bankName: '销方开户行',
    accountNo: '销方银行账号',
    contactAddr: '销方地址',
    contactTel: '销方电话',
    partnerTaxNo: '购方税号',
    partnerContactAddr: '购方地址',
    partnerContactTel: '购方电话',
    partnerBank: '购方银行',
    partnerBankName: '购方开户行',
    partnerAccountNo: '购方银行账号',
    partnerContactMobile: '购方手机',
    partnerProperty: '购方性质',
    taxInvoiceType: '税票种类',
    taxMail: '电子邮箱',
    preTaxInvoiceAmount: '税票不含税金额',
    preTaxInvoiceAmount03: '合计金额',
    taxAmount: '税票税额',
    taxAmount02: '合计税额',
    taxRemark: '税票备注',
    taxParticular: '申请说明',
    otherInformation: '其他信息',
    taxCodeVersion: '编码表版本号',
    propertyRightCode: '产权码',
    authenticateCode: '鉴权码',
    priceTaxSepFlag: '是否需要价税分离',
    taxInvoiceUser: '开票人',
    receiptUser: '收款人',
    checkUser: '审核人',
    specialInvoiceType: '特殊发票类型',
    deviceType: '设备类型',
    extNo: '分机号',
    terminalNo: '终端号',
    applicationUserRemark: '申请人',
    proInformation: '项目信息',
    itemName: '项目名称',
    unit: '计量单位',
    specification: '规格型号',
    tradeCompanyType: '发票性质',
    zeroRateType: '零税率标识',
    taxReliefCode: '减免税性质代码',
    deduction: '扣除额',
    favorablePolicy: '优惠政策',
    favorableParticular: '优惠说明',
    taxClassify: '税收分类编码',
    quantity: '项目数量',
    price: '项目单价',
    taxRate: '税率',
    tax: '税额',
    taxTotalAmount: '项目总价',
    projectSplit: '项目拆分',
    redFlush: '红冲',
    toVoid: '作废',
    readyRedFlush: '已红冲',
    readyToVoid: '已作废',
    notSaved: '未保存',
    image: '影像',
    getImage: '影像获取',
    seeImage: '影像查看',
    uploadImage: '影像上传',
    seeTax: '发票预览',
    assBlue: '关联蓝票',
    seeStatus: '查看发送状态',
    submitStatus: '请求状态',
    businessNo: '业务单号',
    taxInvoiceNo: '发票号码',
    taxInvoiceCode: '发票代码',
    taxRelief: '减免税',
    code: '性质代码',
    rcParticular: '红冲、作废原因',
    rcParticularFlag: '红冲、作废原因标识',
    index: '指数值',
    oriTaxInvoiceInfo: '蓝票信息',
    oriTaxInvoiceNo: '原发票号码',
    oriTaxInvoiceCode: '原发票代码',
    redInvoiceNo: '专用发票红字信息表编号',
    remark: '备注',
    reject: '驳回',
    submitSuccessfully: '提交成功',
    submitFailed: '提交失败',
    rejectSuccessfully: '驳回成功',
    rejectFailed: '驳回失败',
    pleaseSaveFirst: '请先保存',
    splitAndMainUnequal: '项目拆分里的“项目总价”必须小于等于主信息里的“税票金额”',
    notDelete: '请求状态必须为“未发送”',
    otherManagement: '其他费用管理',
    voyageExpenses: '航次杂费发票管理',
    invalidFlag: '是否作废',
    paymentIdentification: '收付标识',
    moveUp: '上移',
    moveDown: '下移',
    receivable: '应收金额',
    payable: '应付金额',
    dueDate: '到期日',
    approvalStatus: '审批状态',
    settleStatus: '核销状态',
    invoiceDate: '发票日期',
    invoiceTypeNew: '发票类型',
    invoiceCurrencyNew: '币种',
    invoiceAmountNew: '金额',
    vessel: '船舶',
    contractNo: '合同号',
    particular: '费用说明',
    rpType: '收/付',
    vvl: '船名/航次',
    voyageExpensesEdit: '航次杂费发票编辑',
    detailGeneralCheck: '应付金额必须大于或等于应收金额!',
    detailShipCheck: '费用明细船名必须一致',
    detailContractCheck: '费用明细合同号对应的签约主体必须一致',
    submitForApproval: '提交审批',
    paymentApply: '付款申请',
    print: '打印',
    baseInfo: '基本信息',
    invoiceNumber: '发票号',
    currencyAndRate: '币种/汇率',
    settledAmountNew: '已核销金额',
    settleCompanyNew: '我方结算公司',
    partnerAccountNoNew: '合作方银行账号',
    partnerAccountName: '合作方账户名称',
    partnerBankNameNew: '合作方银行名称',
    accountNoNew: '我方银行账号',
    accountName: '我方账户名称',
    bankNameNew: '我方银行名称',
    paymentNo: '付款申请单号',
    particularNew: '费用详情',
    expenseDetail: '费用明细',
    copyAdd: '拷贝新增',
    otherChargeExport: '费用明细导出',
    batchUpdate: '批量更新',
    port: '港口',
    chargeName: '费用类型',
    quantityNew: '数量',
    unitPrice: '单价',
    amountAr: '应收',
    amountAp: '应付',
    currencyNew: '币种',
    chargeCompany: '费用承担公司',
    finType: '承保类型',
    payee: '受益人',
    apTotal: '应付合计',
    arTotal: '应收合计',
    total: '总计',
    generalExpenses: '通用费用发票管理',
    amount: '金额',
    rpTypeFlag: '收/付',
    rInvoice: '应收发票',
    pInvoice: '应付发票',
    atLeastOne: '请选择至少一条数据',
    checkFlag: '审核标志',
    submitFlag: '应收应付',
    audit: '审核',
    cancelAudit: '取消审核',
    invoiceApproval: '应收发票审批',
    auditSuccess: '审核成功',
    cancelAuditSuccess: '取消审核成功',
    invalidInvoiceNoNotEmpty: '废弃发票号不能为空',
    invalidInvoiceNo: '废弃发票号',
    associateInvalidInvoiceNo: '关联废弃发票号',
    associateInvalidInvoiceNoCheck: '当前发票已经关联废弃发票号：{invoiceNo}，是否继续？',
    copy: '复制',
    invalid: '作废',
    invalidSuccess: '作废成功',
    generalExpensesEdit: '通用费用发票编辑',
    subjectTitle: '标题',
    customer: '客户',
    createdBy: '制单人',
    settleFlag: '结算标志',
    receiptDate: '实收日期',
    createDate: '制单日',
    cancelReceiveApply: '申请取消收款',
    invalidAndRedo: '废弃并重开发票',
    currentStatus: '当前状态',
    handleUser: '当前处理人',
    receiveStatus: '收款状态',
    invoiceApprovalSearch: '发票审批查询',
    receiptAndPayment: '收付款审批管理',
    receiptInvoiceDetail: '应收发票审批明细',
    submitShare: '提交共享 ',
    haveRead: '已阅',
    viewImage: '查看影像文件',
    uploadImages: '上传影像文件',
    invoiceInfo: '发票信息',
    approvalOpinion: '审批意见',
    attachmentInfo: '附件信息',
    amountTotal: '金额合计',
    installment: '发票期数',
    voyageNoAndContract: '航次/合同类型',
    broker1Name: '经纪人',
    broker2Name: '经纪人2',
    broker3Name: '经纪人3',
    brokerName: '经纪人',
    currentApprovalStatus: '当前环节',
    buildTime: '制单时间',
    contractType: '合同类型',
    operateSuccessfully: '操作成功',
    settleStatusNew: '结算状态',
    isChecked: '是否审核',
    isSubmit: '提交应收应付',
    isInvalid: '是否作废',
    isElectSeal: '电子印章',
    checkFailure: '校验不通过',
    disbursementManagement: '港使费管理',
    disbursementEstimate: '港口使费预估',
    country: '国家地区',
    agent: '代理',
    isChina: '是否中国',
    isOwnerFlag: '是否自有船',
    voyageStatus: '航次状态',
    portName: '港口名称',
    agentName: '当地代理',
    originCurrency: '原币',
    originAmount: '原币金额',
    baseCurrency: '本币',
    baseAmount: '本币金额',
    checkStatus: '审核状态',
    pdaFlag: '备用金状态',
    paymentStatus: '付款状态',
    lastModifyByName: '修改人',
    lastModifyTime: '修改时间',
    feesSetting: '费用项目设置',
    shipDispatch: '船舶调度',
    inverseApproval: '反审核',
    pettyCashApply: '备用金申请',
    historyAgencyFee: '历史代理费',
    historyDisbursement: '历史港使费',
    localAgent: '本地代理',
    origAndRate: '原币/汇率',
    dockRepair: '坞修',
    vesselBuildFlag: '新造船',
    inCostFlag: '计入营运成本',
    isPdaApplied: '备用金申请',
    paymentStatusNew: '备用金实付',
    disbursementDetail: '港使费明细',
    discount: '折扣(%)',
    reducedAmount: '折扣金额(原币)',
    baseReducedAmount: '折扣金额(本币)',
    discountAmount: '原币金额(折扣后)',
    discountBaseAmount: '本币金额(折扣后)',
    countTotal: '合计',
    pdaApply: '备用金申请',
    createdByNew: '创建人',
    approvalProcess: '查看审批流程',
    pdaDelete: '未付款申请删除备用金',
    cancelPay: '未付款情况取消付款并作废申请',
    differentAgentChangePort: '已付款情况不同代理改港',
    sameAgentChangePort: '已付款情况相同代理改港',
    agentNameNew: '代理名称',
    payDueDate: '付款到期日',
    agentCode: '代理编号',
    isSubmitted: '是否提交应付',
    portChargeInfo: '查看港口使费预估信息',
    totalBalanceAmount: '余额',
    applyAmount: '申请金额',
    applyCurrency: '申请币种',
    offsetAmount: '抵扣备用金金额',
    paymentAmount: '本期实际申请金额',
    basePaymentAmount: '本币金额',
    docNo: '单据编号',
    paymentDueDate: '付款到期日',
    balanceDetail: '本次抵扣备用金余额清单',
    fdaInvoiceNo: '实际港使费发票号',
    offsetAmountNew: '本单抵扣',
    add: '添加',
    pdaBalanceAmount: '备用金余额',
    createTime: '创建时间',
    payApply: '付款申请单管理',
    payeeName: '收款人',
    supplier: '供应商',
    approvalStatusNew: '申请状态',
    freightType: '费用类型',
    shareStatus: '共享审核状态',
    receiptDateNew: '实付日期',
    paymentPriority: '紧急程度',
    payCurrency: '付款币种',
    payAmount: '付款金额',
    payApprovalStatus: '申请单状态',
    handleUserName: '当前处理人',
    paidDate: '实付日期',
    bankSlip: '银行回单',
    payCancel: '取消付款',
    reportInfo: '报备信息',
    checkBankInfo: '查看银行回单',
    printOrder: '打印面单',
    printPdf: '打印PDF',
    company: '公司',
    createdPerson: '经办人',
    createdDep: '部门',
    paymentMeans: '付款方式',
    amountForNow: '本期应付金额',
    paymentParticular: '付款事由',
    receiptInfo: '收款信息',
    payeeBankName: '收款银行',
    payeeAccountNo: '收款账户',
    paymentDetail: '付款费用明细',
    receiptDetail: '收款发票明细',
    invoice: '发票/单据号',
    expenseAmount: '费用金额',
    receivedRemark: '收款状态',
    addReceipt: '添加运费租金应收发票',
    invoiceDetail: '保费分期明细',
    insuranceItem: '保险类型',
    underwriteDate: '承保区间',
    installmentNew: '期数',
    payApplyEdit: '付款申请单编辑',
    paymentApplicationForm: '付款申请单',
    paymentNoNew: '单据编号',
    invoiceNoRepeatedly: '发票号不能重复',
    mustInput: '请正确填写所有必填项',
    detailEmpty: '费用明细行不能为空',
    rowNumCheck: '第 {seq} 行: {attribute} 不能为空',
    detailNotSave: '费用明细行未保存',
    demurrageManagement: '滞期费管理',
    calculationOfDemurrage: '滞期费计算',
    frightRentManagement: '运费租金管理',
    rentOutPendingHireFrt: '租出船待处理运费租金',
    rentInPendingHireFrt: '租入船待处理运费租金',
    rentOutHireFrtInvoice: '租出船运费租金发票',
    rentInHireFrtInvoice: '租入船运费租金发票',
    nextPayDay: '下期租金日',
    nextDay: '下期时间',
    currentPeriod: '当前期数',
    type: '类型',
    agreement: '合同',
    renter: '租家',
    shipOwner: '船东',
    delayTime: '滞期时间(天)',
    dispatchTime: '速遣时间(天)',
    lagTime: '滞速时间(天)',
    demurrageCharges: '滞期费',
    dispatchMoney: '速遣费',
    adjustmentAmount: '调整金额',
    total2: '合计总额',
    importInvoice: '导入发票',
    updateDocument: '更新单据',
    viewContract: '查看合同',
    uploadAttachments: '上传附件',
    generateDelayFeeInvoice: '生成滞速费发票',
    shipSource: '船舶来源',
    cargo: '货物',
    billReceiver: '收票方',
    invoicingParty: '开票方',
    totalLoadingAndUnloading: '装卸合计',
    demurrageChargesDay: '滞期费(/天)',
    dispatchFee: '速遣费(/天)',
    portList: '港口列表',
    purpose: '目的',
    cargoVolume: '货量',
    handlingEfficiency: '装卸效率',
    unit1: '单位',
    demurrageClause: '滞期费条款',
    startTime: '开始时间',
    startDate: '开始日期',
    startClause: '开始日期描述',
    completionTime: '完成时间',
    completionDate: '完成日期',
    completionClause: '结束日期描述',
    expectedTime: '期望时间',
    percentage: '%',
    usageTime: '使用时间（天）',
    allowedTime: '允许时间（天）',
    allowedTime2: '允许时间',
    earlyLoadingTime: '早装时间（天）',
    earlyLoadingTime2: '早装时间',
    deductionTime: '扣减时间（天）',
    deductionTime2: '扣减时间',
    date: '日期',
    week: '星期',
    time: '时间（小时）',
    adjustmentAmount2: '调整量（%）',
    finalTime: '最终时间（天）',
    cumulativeTime: '累计时间',
    operate: '操作',
    delayTime2: '滞期时间（天）',
    demurrageRate: '滞期费率',
    dispatchRate: '速遣费率',
    deductionItems: '扣减/早装项目',
    time2: '时间',
    endTime: '结束时间',
    fatalism: '天数',
    deductibleDays: '可扣减天数',
    cause: '原因',
    describe: '描述',
    boatmanView: '租家观点',
    renterView: '船东观点',
    disputeRecord: '争议记录',
    disputeType: '争议类型',
    processingResults: '处理结果',
    demurrageFee: '滞速费',
    agreementAmount: '协议金额',
    chartererAmount: '租家金额',
    ownerAmount: '船东金额',
    calculationTimeCharge: '滞速费计算时间点',
    importInvoiceOrNot: '是否导入发票',
    SOFDetails: 'SOF明细',
    actualPortCharge: '实际港口使费',
    portCountry: '港口国家',
    isLocked: '是否锁定',
    docApprovalStatus: '单据审批状态',
    paymentApprovalStatus: '付款审批状态',
    docNoNew: '单据号',
    actualAmount: '总实际费用',
    paymentAmountNew: '应付金额',
    invApprovalStatus: '单据状态',
    operationDeptTotal: '营运部汇总',
    engineerDeptTotal: '机务部汇总',
    crewDeptTotal: '船员部汇总',
    superviseDeptTotal: '安监部汇总',
    safetyDeptTotal: '安全质量部汇总',
    createdOffice: '创建部门',
    batchPayApply: '合并付款申请',
    importPortCharge: '导入使费',
    lock: '锁定',
    unlock: '解锁',
    adjustCharge: '调整费用类型',
    adjustInvoiceNo: '调整发票号',
    setPortChargePaid: '标记为港使费已付款',
    portChargeBalanceAmount: '备用金余额',
    paymentNoRepeat: '发票号不能重复',
    deleteFailed: '只能删除审批状态为“草稿”或者“拒绝”的数据',
    onlyDeleteChecked: '只能删除未审核的数据!',
    cancelReceive: '取消收款',
    demurrageDisputeInquiry: '滞期费争议查询',
    contractDate: '合同日期',
    route: '航线',
    contractTemplate: '合同范本',
    issue: '争议点类型',
    relevantContractTerms: '相关合约条款',
    demurrageinvoicemanage: '滞速费发票管理',
    currencyName: '币种',
    endOfVoyage: '航次结束',
    pdaOffsetNotEnough: '备用金余额不足，请刷新后重新操作',
    totalAmount: '总金额',
    arrivalDate: '到港日',
    departureDate: '离港日',
    portPurpose: '抵港目的',
    settlePartnerCode: '结算客商',
    isDocCollected: '发票/单据收齐',
    fdaReceiveDate: 'FDA收到日期',
    applyPda: '申请备用金',
    paymentAmountForNow: '本次付款金额',
    voyageExpensesNew: '航次成本',
    pdaBalanceFlag: '备用金余额处理',
    substitutePartner: '代垫公司',
    allinFlag: '包干',
    substituteFlag: '代垫',
    substitutePartnerNameEn: '代垫对象',
    claimFlag: '可索赔',
    claimNo: '理赔案件号',
    undertakeCompanyNameEn: '费用承担公司',
    csNameEn: '客商',
    partnerNameEn: '实际付款人',
    settleCompanyNameEn: '我方公司',
    currencyCodeBaseAndExchange: '原币/本币/汇率：',
    particularDescribe: '费用描述',
    pdaDiscountAmount: '预估原币金额(折扣后)',
    difference: "差额",
    substituteAmount: '代垫金额',
    spareStoreType: '备件物料类别',
    op: '营运部',
    eg: '机务部',
    cw: '船员部',
    su: '安监部',
    sa: '安全质量部',
    approvalStatusForDoc: '单据审批状态',
    choseInvoiceDate: '请先选择发票日期用以计算汇率',
    substitutePortFee: '代垫港使费',
    cantDelete: '只能删除未审核且审批状态为“草稿”或者“拒绝”的数据',
    fdaAmount: '实际港口使费',
    pdaAmount: '已支付备用金',
    pdaBalanceType: '备用金余额处理方式',
    auditTime: '审核时间',
    delayFeeCalculation: '查看滞速费计算',
    leadingIn: '导入',
    importSuccess: '导入成功',
    contractingEntity: '签约主体',
    surplusPdaQuery: '备用金余额查询',
    submitReceipt: '提交应收',
    setPdaTypeToPda: '设置为备用金类型',
    setPdaTypeToBalance: '设置为余额类型',
    vesselCode: '船舶',
    agentCodeNew: '代理代码',
    portCode: '港口代码',
    balanceAmountNew: '备用金余额',
    pdaType: '备用金类型',
    createOffice: '所属部门',
    portSequence: '港口顺序',
    pdaStatus: '使用情况',
    isBalanceZero: '余额是否为零',
    totalPdaAmount: '备用金余额合计',
    sureUpdatePda: '是否改为“备用金”类型？',
    sureUpdateBalance: '是否改为“余额”类型？',
    updateSuccessfully: '更新成功',
    updateFailed: '更新失败',
    contractNoEmpty: '合同号不能为空',
    modifyRemark: '修改备用金备注',
    pdaDetail: '备用金使用情况',
    offsetStatus: '类型',
    surplusPdaRetrieve: '备用金回收管理',
    partnerNameNew: '客户',
    invRemark: '发票说明',
    surplusPdaRetrieveDetail: '备用金回收单明细',
    receiptApproval: '应收审批',
    bankInfoNew: '银行信息',
    hcbCode: "主数据编码",
    issueInfo: '签发信息',
    chargeInfo: '费用信息',
    chargeNameNew: '费用类型',
    validFailed: '勾选记录要是余额类型，结算客商和币种需要一致，并且余额不能为零',
    handleHomeCurrency: '请维护公司的本位币!',
    marketInformation: '市场信息',
    fuelPriceIndex: '燃油价格指数',
    portFuelPriceIndex: '港口燃油价格指数',
    portFuelPriceIndexDetails: '港口燃油价格指数明细',
    indexDate: '指数日期',
    priceUM: '价格(USD/MT)',
    upDownAmount: '涨跌额',
    fluctuationRange: '涨跌幅%',
    indexType: '指数类型',
    cycleTime: '时间周期',
    queryDate: '查询日期',
    PortSettings: '主要加油港设置',
    pricePreviousDay: '前一天价格',
    dayPrice: '当天价格',
    aparManagement: '应收应付管理',
    settlementAr: '应收管理',
    settlementAp: '应付管理',
    voyageEndDate: '航次结束时间',
    settleMarks: '结算标志',
    partnerNew: '客户',
    customerPay: '付款人',
    invoiceAmountR: '应收金额',
    receiptAmount: '实收金额',
    balanceAmountR: '应收尾数',
    estDueDate: '应收日期',
    voyageEnd: '航次结束',
    voyageEnd5: '航次结束+5',
    settlementArDetail: '应收明细',
    arrears: '尾数',
    dueTime: '应收日期',
    settleCurrency: '结算币种',
    homeCurrency: '本位币',
    exchangeRate: '汇率',
    receiptType: '收款类型',
    receiptInformation: '应收信息',
    actualReceipts: '实收信息',
    freightIndex: '运价指数',
    tankerFreightIndex: '油轮运价指数',
    TCEMean: 'TCE均值(USD$/DAY)',
    TCEMean2: 'TCE均值',
    TCEFluctuation: 'TCE涨跌额',
    TCEUpsDowns: 'TCE涨跌幅%',
    detailsOfTankerFreightIndex: '油轮运价指数详情',
    indexPreviousDay: '前一天指数',
    indexDay: '当天指数',
    TCEDayBefore: '前一天TCE',
    indexRounte: '航线',
    indexText: '*双击可查看或维护更详细指数类型数据',
    saveSuccess: '保存成功',
    saveFailed: '保存失败',
    dryBulkFreightIndex: '干散运价指数',
    detailsOfDryBulkFreightIndex: '干散运价指数详情',
    prepaidCancellation: '冲销预收',
    payerBankAccount: '收款银行账号',
    bankCharges: '银行手续费',
    annotation: '批注',
    notNull: '至少要保留一条数据',
    payAmountNew: '应付金额',
    paidAmount: '实付金额',
    payBalanceAmount: '应付尾数',
    voyageEndTime: '航次结束',
    settleAmount: '实付金额',
    settleDate: '实付日期',
    duePayDate: '应付日期',
    bankSlipNew: '银行水单',
    settlementApDetail: '应付明细',
    actualPayInfo: '实付信息',
    approvalHistory: '审批流程',
    processName: '步骤名',
    department: '部门',
    handler: '处理人',
    arrivalTime: '到达时间',
    handleTime: '处理时间',
    timeGap: '时间间隔',
    status: '状态',
    historyAgentCharge: '历史代理费',
    ourBankInfo: '我方公司银行信息',
    partnerBankInfo: '结算客商银行信息',
    filterInvoiceNo: '可查询发票号',
    invoiceNoSubject: '可查询发票号、标题',
    payInvoiceNo: '可查询发票号、付款申请单号、收款人',
    filterRemark: '可查询备注',
    taxReceiptInfo: '供应商税票信息',
    withdraw: '撤回',
    invoiceCode: '发票代码',
    invoiceNumberNew: '发票号码',
    invoiceAcceptDate: '发票接受日期',
    download: '下载模板',
    isOffset: '是否抵扣',
    offsetAmountOff: '可抵扣金额',
    invoiceCurrency: '发票币种',
    preTaxInvoiceAmountNew: '不含税金额',
    taxMoney: '税金',
    invoiceMoney: '发票金额',
    invoicePartner: '开票方',
    partnerTaxNumber: '企业识别号',
    partnerAddrTel: '地址及电话',
    bankAccount: '银行及账号',
    receiptCompany: '收票方',
    taxNo: '企业识别号',
    addrTel: '地址及电话',
    bankAndAccount: '银行及账号',
    serviceNameNew: '项目名称',
    chargeRelate: '关联项目',
    preAmount: '金额',
    taxRateNew: '税率（%）',
    taxAmountNew: '税额',
    invoiceTaxAmount: '含税金额',
    submitFlagNew: '是否提交',
    supplierAdd: '供应商税票明细',
    submit: '提交',
    invoiceOcr: '发票图片识别',
    billingDetails: '加载账单明细',
    specificationNew: '规格',
    deleteImage: '删除影像文件',
    submitSuccess: '提交成功',
    successfulWithdrawal: '撤回成功',
    onlyOne: '至多选择一条数据',
    amountDifferent: '主信息与费用明细的费用不一致！',
    amountDiff: '发票与税票费用不一致！',
    alreadySubmit: '税票已提交，无法删除。',
    shareSuccess: '提交共享成功',
    checkBanInfo: '请检查银行信息是否正确',
    checkHomeCurrency: '请维护公司的本位币',
    checkInvoiceNo: '请维护发票号',
    checkBatchPay: '币种、结算客商、备用金余额处理方式须一致，并且审批状态为“通过”，以及提交应付标志为“否”',
    portChargeAmount: '港口使费预估',
    sameAmount: '总实际费用应与各费用表格的原币金额(折扣后)合计金额一致',
    payApproveStatus: '付款申请单状态',
    settleOffice: '结算公司',
    sendFlag: '发送状态',
    sendDate: '发送时间',
    apNo: 'AP单据号',
    voucherNo: '凭证号',
    returnStatus: '共享反写状态',
    auditInformation: '共享反写信息',
    auditDate: '共享审核日期',
    settleAmountNew: '核销金额',
    arNo: 'AR单据号',
    isTaxInv: '是否已开税票',
    saveFirst: '请先进行保存',
    invoiceDates: '发票日',
    receiptDates: '实收日',
    applyStatus: '申请单状态',
    agentInfo: '当前',
    totalPreTaxInvoiceAmount: '不含税金额合计',
    totalTaxAmount: '税金合计',
    totalInvoiceAmount: '发票金额合计',
    noImage: '没有对应的影像文件，请先上传！',
    pdaNotEnough: '备用金余额不足，不能保存',
    pleaseSaveData: '请先保存数据',
    ocrFail: '发票识别失败',
    selectOpt: '请选择审批操作',
    unsettleAmount: '尾数',
    paidType: '付款类型',
    payApprovalProcess: '付款审批流程',
    docApprovalProcess: '单据审批流程',
    pleaseUpdateRate: '请维护当前币种的汇率',
    fillTable: '请维护表格中所有的必填字段',
    notaxAmount: '不含税金额',
    exTaxation: '税金',
    exTaxation2: "税金",
    voyageCostFlag: '航次成本',
    tipOne: '状态必须为未发送且未关联蓝票信息',
    tipTwo: '状态必须为成功或者状态为未发生且关联蓝票信息',
    tipThree: '状态必须为成功且未关联蓝票信息',
    sendSuccess: '发送成功',
    tip: '提示',
    isSend: '是否发送',
    isRedFlush: '是否红冲',
    isToVoid: '是否作废',
    pleaseChooseOneSend: '请选择你要发送的组织',
    mustHasRcParticular: '红冲或废弃原因不能为空',
    redFlushSuccess: '红冲成功',
    toVoidSuccess: '作废成功',
    totalFormTo: '总价区间',
    sendInfo: '当前【蓝票】发送信息预览',
    redFlushInfo: '当前【红冲】发送信息预览',
    toVoidInfo: '当前【作废】发送信息预览',
    nameCn: '企业中文名称',
    nameEn: '企业英文名称',
    invoiceHeader02: '发票抬头',
    taxNumber02: '税号',
    contactAddress: '联系地址',
    phone: '电话',
    cantDeleteNew: '只能删除锁定状态为“否”且审批状态为“草稿”或者“拒绝”的数据',
    check: '查看',
    preview: '发票预览',
    voyageOtherFee: '航次杂费查询',
    commission: '佣金',
    commissionTitle: '经纪人佣金发票',
    addBrokerageFee: '新增经纪人佣金',
    generateNewInvoice: '生成新发票',
    generateNewInvoiceCheck: '必须勾选作废的发票，才能生成新发票',
    rentBillDonotrebill: '滚动账单不支持重开票',
    generateNewInvoice2: '该废弃发票已存在新发票',
    selectOne2: '只能选择一条发票废弃',
    selectOne: '请选择一条数据',
    invoiceStatus: '发票状态',
    obtainIndexRent: '获取指数租金',
    addExpenses: '新增杂费',
    defaultInitializationFee: '默认初始化费用',
    checkTheInitializationFee: '勾选初始化费用',
    brokerCommFee: '金额（计经纪人佣金）',
    importFromOrder: '从订单导入',
    invoiceDetails: '发票明细列表',
    commissionDetailCheck: '请至少维护一笔费用明细!',
    saveCommission: '添加佣金',
    lockSuccess: '锁定成功',
    unlockSuccess: '解锁成功',
    tempOffset: '冲销反写',
    obtain: '获取',
    view: '查看',
    upload: '上传',
    isObtain: '是否获取影像',
    isView: '是否查看影像',
    isUpload: '是否上传影像',
    obtainSuccess: '影像获取成功',
    obtainFail: '影像获取失败',
    uploadSuccess: '影像上传成功',
    uploadFail: '影像上传失败',
    uploadExist: '影像已上传，请点击查看',
    partnerNotNull: '请维护结算客商',
    currencyNotNull: '请维护结算客商',
    pdaOffsetAdd: '添加备用金余额抵扣',
    pdaOffsetDelete: '删除备用金余额抵扣',
    pdaOffsetSearch: '查看抵扣备用金余额清单',
    onlyPda: 'Only PDA balances can be deleted',
    invalidAndRestartInvoice: '废弃并重开发票',
    cancelReceiveSuccess: '取消收款成功',
    adjustCollectionInfo: '调整收款信息',
    send: '发送',
    adjustSuccess: '调整成功',
    bankOfDeposit: '开户行',
    bankAccountNumber: '银行账号',
    noCreateOffice: '创建部门不能为空!',
    noTaskCode: 'TaskCode不能为空!',
    submitShareSuccess: '提交共享成功',
    unApproval: '反审批',
    cancelPaySuccess: '取消付款成功',
    shareAuditDate: '审核日期',
    shareAuditor: '审核人',
    shareAuditInfo: '审核信息',
    shareInfo: '共享审核信息',
    returnToCreator: '返起草人',
    update: '更新',
    updateFreightTerms: '更新运价条款',
    portNameEn: '港口英文名称',
    bunkerPort: '加油港',
    returnCreatorSuccess: '返起草人成功',
    workFlowNotPass: '请先完成审批',
    approvalOpinionForCancel: '取消收款审批意见',
    approvalOpinionForInvalid: '废弃并重开发票审批意见',
    updateInfo: '更新信息',
    checkDocStatus: '请检查单据状态',
    submitApproveSuccess: '提交审批成功',
    repeatDocNo: '单据号不能重复',
    viewPda: '查看备用金',
    noPda: '尚未申请备用金',
    discountNotaxAmount: '原币不含税金额（折扣后）',
    baseExTaxation: '本币税金',
    discountBaseNotaxAmount: '本币不含税金额（折扣后）',
    paymentAmountLimit: '合计本次付款金额必须大于等于0',
    paymentAmountZeroLimit: '本次付款金额应大于0',
    userToApproval: '待审批人',
    userToApprovalNext: '下级审批人',
    payFinConfig: '付款单财务审批配置',
    recFinConfig: '应收单财务审批配置',
    fdaAdd: '新增实际港口使费',
    opsSettleOffice: '经营公司',
    estimateAmount: '预估金额',
    viewPdaBalance: '查看备用金余额清单',
    viewPdaBalanceList: '查看备用金余额清单',
    balance: '余额',
    pdaRecycleNo: '备用金回收单号',
    signSubject: '签约主体',
    payCurrencyAndRate: '支付币种/汇率',
    amountForPay: '支付金额',
    shareAuditUser: '共享审核人',
    payDate: '付款日期',
    payBank: '水单影像号',
    settlementAm: '原币核销金额',
    noImageNo: '暂无影像编码',
    shareReturnDate: '反写日期',
    bankCharge: '手续费金额',
    payParticular: '详情',
    payPlan: '付款计划',
    universalList: '万能单分录明细',
    viewUniversal: '查看万能单',
    discountMoney: '折扣金额',
    baseAmountTax: '本币税额',
    baseAmountPayable: '本位币应付金额',
    costElement: '成本要素',
    costNature: '费用性质',
    specialCount: '个性统计',
    buildTimeNew: '建立日期',
    goodsShipping: '收货船舶',
    category: '品种',
    actualTotalPrice: '实际总价',
    goodsDate: '收货日期',
    goodsQuantity: '收货数量',
    basePaymentAmountNew: '本币应付金额',
    chargeNameFin: '费用科目',
    claimFlagNew: '可索赔标识',
    originAmountPay: '支付金额',
    reducedAmountPay: '折扣金额(支付)',
    discountAmountPay: '支付金额(折扣后)',
    discountNotaxAmountPay: '支付不含税金额（折扣后）',
    orderInfo: '订单信息',
    arAmount: '应收金额',
    baseArAmount: '应收金额本位币',
    revTypeCode: '收款往来类型编码',
    revCash: '收款客户',
    routeLine: '航线',
    portAgentNo: '港口代理号',
    revPlan: '收款计划',
    receivableDate: '应收日期',
    detailInfo: '明细信息',
    receiptDetailNew: '开票明细',
    invoiceName: '客户开票名称',
    taxpayerNum: '纳税人识别号',
    accountNoForRec: '开户行及账号',
    invoiceNum: '发票号码',
    addressTelephone: '地址电话',
    responseMessage: '响应信息',
    deletePda: '未付款申请删除备用金',
    notPayApply: '所选备用金未提交付款申请至共享中心',
    pdaPaid: '所选备用金已付款,无法取消付款并作废申请',
    passToDelete: '付款审批通过后才能取消付款',
    uploadImageTip: '是否需要上传影像文件',
    cantUpdateForShare: '付款申请单已提交共享，不能修改付款到期日',
    updateDueDate: '更新付款到期日',
    payForChangePort: '备用金未付款，不能改港',
    yes: '是',
    no: '否',
    swiftCode: 'SWIFT CODE',
    recoverSuccess: '恢复成功',
    recover: '恢复',
    balanceSelected: '所选备用金类型为余额，无法进行已付款情况不同代理改港',
    portSequenceNew: '港序',
    currentApproveStatus: '当前状态',
    invalidContractType: '发票的合同状态为作废，无法做应收单',
    endContractType: '发票的合同状态为终止，确定要继续开具应收审批单？',
    pdaNewPort: '是否为无航次挂港的数据？确定后港口及代理数据将可编辑。',
    queryImageCount: '查询影像张数',
    undertakeCompany: '承担公司',
    updateDetailInfo: '是否确定更新费用明细？',
    insInvoiceApprovalDetail: '保险应收审批单',
    insInvoiceDetail: '发票明细',
    receiptSplit: '应收单拆分',
    notShare: '未提交共享',
    shared: '已提交共享',
    receiptNo: '应收单号',
    shareChecked: '共享审核',
    shareReturn: '共享打回',
    received: '已收款',
    deleteDraft: '只能删除审批状态为“草稿”或者“拒绝”并且未提交共享的应收单',
    payReport: '付款报备',
    deleteImageSuccess: '删除影像文件成功',
    uploadAttachmentsImages: '上传附件影像文件',
    uploadImageSuccess: '上传附件影像成功',
    AssociateChiefData: '关联大副数据不能为空',
    updateFdaInfo: '更新发票号,发票日期,到期日',
    getReportUrlFailed: '获取报备回执地址失败',
    businessRepresentative: '商务员',
    fd: '财务部',
    cancelReason: '取消收款原因',
    invalidlReason: '废弃原因',
    viewCancelProcess: '查看取消收款/废弃重开发票审批单',
    allAmount: '总金额',
    invalidAndRestartSuccess: '废弃并重开成功，已自动生成发票：',
    voyageRange: '航次范围',
    invalidConfirm: '是否作废该记录',
    sendAndChangePort: '更新港口并通知财务',
    pdaInfo: '备用金信息',
    payStatus: '付款状态',
    oldPortInfo: '旧港口信息',
    newPortInfo: '新港口信息',
    paymentReportCheck: '“未上平台采购的证明文件”附件类型的附件起码要有一个 并且“报价清单文件”的附件起码要有一个',
    cancelReceiptApproval: '取消收款审批',
    restartApproval: '废弃并重开发票审批',
    cancelReceiptApprovalDetail: '取消收款审批明细',
    restartApprovalDetail: '废弃并重开发票审批明细',
    invoiceNoPaymentNoTitle: '可查询发票号、付款申请单号、标题',
    overdueFlag: '逾期状态',
    localApproval: '本地审批：各环节提交时间及耗时(小时)',
    consumeTime: '耗时(小时)',
    sendDate01: '提交共享时间',
    shareAuditTime: '共享审核时间',
    paidDate01: '实际付款时间',
    freightType01: '付款单类型',
    dueDate01: '付款到期日',
    waybillNoAndInvoiceNo: '可查询发票号、运单号',
    sendDate02: '寄出日期',
    courierCompany: '快递公司',
    waybillNo: '运单号',
    recipient: '收件人',
    invoiceNo01: '涉及发票',
    vesselNameAndVoyageNo: '涉及船名航次',
    createName: '创建人',
    createName01: '加入运单人',
    createTime01: '加入运单时间',
    expressStatus: '状态',
    deleteFailed01: '删除的记录必须是未寄出',
    invoiceCreateName: '发票创建人',
    expressStatusRemark: '寄出状态',
    confirmSendOff: '寄出确认',
    customerSignOfConfirm: '客户签收确认',
    invoiceNoAndCargo: '可查询货物',
    timeOfArrival: '到港时间',
    timeOfDeparture: '离港时间',
    estAmount: '预估使费',
    fdaActualAmount: '实际使费',
    pdaApplyAmount: '申请备用金',
    portAgent: '港口代理',
    pdaPaidDate: '预付款日',
    fdaSettleType: 'FDA结算类型',
    fdaNoAndPdaNo: '可查询FDA发票号和PDA付款单号',
    pdaPaymentNo: 'PDA付款单号',
    pdaPaidTime: '预付款日期',
    pdaBalanceAmountNew: '当前余额',
    balanceHistory: '余额历史',
    pdaBalancesType: '余额类型',
    fdaNoInvoice: 'FDA发票号',
    overDueDays: '逾期天数',
    fdaCurrencyCode: '币种（FDA）',
    fdaInvoiceAmount: 'FDA金额',
    offsetAmountForNow: '本次抵扣备用金金额',
    fdaRpBalance: '本次结余',
    settleType: '结算类型',
    fdaApprovalStatus: 'FDA审批状态',
    payApplyApprovalStatus: '付款申请审批状态',
    fdaSettleDate: 'FDA财务结算日期',
    agentSettleDate: '代理结算日期',
    agentSettleFlag: '是否代理结算',
    viewCancel: '查看取消收款审批单',
    viewInvalid: '废弃重开发票审批单',
    inChinaFlag: '国内/国外',
    discountRate: '折扣比例(%)',
    disAmount: '折扣后金额',
    reduceAmount: '折扣金额',
    selectFeeType: '请选择费用类型',
    handleTaskNode: '当前处理环节',
    dpDate: '离港日期',
    dpDateMore: '离港日期+30天',
    fdaCheckDate: 'FDA费用审核发起时间',
    fdaOffsetBalance: 'FDA抵扣后预计余额',
    balanceRecoveryDate: '余额回收发起日期',
    balanceSettleDate: '余额收到日期',
    balanceOffsetDate: '余额抵扣日期',
    currentWorkflow: '当前流程',
    index1: '指标1',
    index2: '指标2',
    index3: '指标3',
    oldPortNameEn: '历史改港',
    balanceChangePort: '所选备用金类型为余额，无法进行已付款情况相同代理改港',
    payName: '付款人',
    signArea: '地区',
    year: '年份',
    sealNo: '流水号',
    cancelInvoiceNo: '废弃发票号',
    particularDes: '描述',
    ageDate: '账龄日期',
    analysisType: '分析类型',
    voyageLine: '航线名称',
    regions: '地区',
    receiveDate: '收款日期',
    aging: '账龄',
    day30: '30天以内',
    day90: '31-90天',
    day180: '91-180天',
    day365: '181-365天',
    day730: '366-730天',
    day99999: '730天以上',
    collectionDate: '催收日期',
    chartererReplyDate: '租家回复日期',
    ownerCounterDate: '船东回复日期',
    collectionContent: '最新跟踪内容',
    vesselType: '船舶类型',
    indexFlag: '指标筛选',
    inputDepTime: '请输入离港开始时间',
    inputAnalysisType: '请选择分析类型',
    inputAgeDate: '请选择账龄日期',
    customerReply: '租家回复跟踪',
    collectionInfo: '催收内容',
    counterDate: '船东COUNTER日期',
    currencyExchangeRate: '申请币种/汇率',
    otherFinInfo: '其他财务信息',
    newBaoBei: '新增报备信息',
    editBaoBei: '编辑报备信息',
    remake: '重新起草',
    bankAccountNo: '银行账号',
    updateMainInfo: '是否更新发票号、发票日期和到期日',
    inputMainInfo: '请维护发票号、发票日期和到期日',
    vesselFlag: '自有船/租入船',
    agingRange: '账龄区间',
    noBankImage: '尚未收到银行回单',
    bankImageNo: '银行回单影像编码',
    lastMonth: '上月',
    thisMonth: '本月',
    receiveBack: '收回',
    changeAmount: '变化量',
    payCustomer: '付款方',
    settleCurrencyCode: '结算币种',
    portQuantity: '港口数量',
    selectSettleOfficeCode: '请选择经营公司',
    noResultToReport: '无查询结果，不需要导出',
    receivingSide: '收款方',
    payeeSearch: '可查询收款方',
    sureToCancel: '是否确认取消付款？',
    aPortTime: '抵港时间',
    unReceivedAmount: '未收金额',
    confirmremoval: '确定移除'
  }
};